const filterDetails = document.querySelector('.twoyou-search details.twoyou-search--filters');
const filterDetailsToggleClass = 'has-toggle-ability';
const widthLimit = 540;

/**
 * Update search filter toggle state
 */
const updateFilterDetailsState = () => {
  if (
    window.innerWidth < widthLimit &&
    filterDetails.classList.contains(filterDetailsToggleClass)
  ) {
    return;
  }

  if (window.innerWidth < widthLimit) {
    filterDetails.removeAttribute('open');
    filterDetails.classList.add(filterDetailsToggleClass);
    return;
  }

  filterDetails.classList.remove(filterDetailsToggleClass);
  filterDetails.setAttribute('open', true);
};

if (filterDetails) {
  updateFilterDetailsState();
  window.addEventListener('resize', updateFilterDetailsState);
}
